const AWS = require("aws-sdk");
import settingsService from "./settingsService";

// AWS configuration will be loaded from API
let awsConfig = null;
let cloudfront = null;
let cloudfrontParams = null;

/**
 * Generate a unique filename for S3 storage.
 * Uses crypto.randomUUID (available in modern browsers) with a ms timestamp
 * fallback, always preserving the original file extension.
 * This avoids all Unicode / length / collision issues with user-supplied names.
 */
function generateFileName(originalName) {
  const lastDot = originalName.lastIndexOf('.');
  const ext = lastDot >= 0 ? originalName.slice(lastDot).toLowerCase() : '';
  const uid = (typeof crypto !== 'undefined' && crypto.randomUUID)
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
  return uid + ext;
}

/**
 * Initialize AWS configuration from API
 * @returns {Promise} Promise that resolves when AWS config is loaded
 */
async function initializeAwsConfig() {
  if (awsConfig) {
    console.log("Using cached AWS config:", awsConfig);
    return awsConfig; // Return cached config if already loaded
  }

  try {
    console.log("Loading AWS config from settings service...");
    awsConfig = await settingsService.getAwsConfig();
    console.log("AWS config loaded successfully:", awsConfig);

    // Initialize CloudFront with the loaded config
    cloudfront = new AWS.CloudFront({
      region: awsConfig.bucketRegion,
      accessKeyId: awsConfig.accessKeyId,
      secretAccessKey: awsConfig.secretAccessKey,
      Bucket: awsConfig.bucketName,
    });

    // Initialize CloudFront invalidation parameters
    cloudfrontParams = {
      DistributionId: awsConfig.cloudfrontDistributionId,
      /* required */
      InvalidationBatch: {
        /* required */
        CallerReference: "'" + Math.floor(Date.now() / 1000) + "'",
        /* required */
        Paths: {
          /* required */
          Quantity: 1,
          /* required */
          Items: [
            "/app/v1.json", // Only invalidate the specific file being updated
          ],
        },
      },
    };

    return awsConfig;
  } catch (error) {
    console.error("Failed to initialize AWS configuration:", error);
    throw new Error("Unable to load AWS configuration from API");
  }
}

export default {
  async uploadToS3(file, banner, callback) {
    try {
      // Initialize AWS configuration
      const config = await initializeAwsConfig();

      let s3bucket = new AWS.S3({
        region: config.bucketRegion,
        accessKeyId: config.accessKeyId,
        secretAccessKey: config.secretAccessKey,
        Bucket: config.bucketName,
        endpoint: config.s3Endpoint,
        s3ForcePathStyle: true,
      });

      s3bucket.createBucket(function (data) {
        // Determine ContentType from file extension
        let contentType = "image/jpeg"; // default
        const fileName = file.name.toLowerCase();
        if (fileName.endsWith(".png")) {
          contentType = "image/png";
        } else if (fileName.endsWith(".gif")) {
          contentType = "image/gif";
        } else if (fileName.endsWith(".jpg") || fileName.endsWith(".jpeg")) {
          contentType = "image/jpeg";
        }

        // Generate date-based path
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");

        const safeFileName = generateFileName(file.name);
        var params = {
          Bucket: config.bucketName,
          Key: `uploads/${year}/${month}/${safeFileName}`,
          Body: file.data,
          ContentType: contentType,
          ACL: 'public-read',
        };

        s3bucket.upload(params, function (err, data) {
          if (err) {
            callback(err);
          } else {
            var paramss = {
              Bucket: config.bucketName,
              Key: "app/v1.json",
            };
            s3bucket.getObject(paramss, function (err, existingdata) {
              var defaultJson = { view: { top_banner_image_url: "", top_banner_link_url: "" }, view_us: { top_banner_image_url: "", top_banner_link_url: "" } };
              var json = (existingdata && existingdata.Body)
                ? JSON.parse(existingdata.Body.toString("utf-8"))
                : defaultJson;
              if (banner == "US") {
                if (!json.view_us) json.view_us = {};
                json.view_us.top_banner_image_url = data.Location;
              } else {
                if (!json.view) json.view = {};
                json.view.top_banner_image_url = data.Location;
              }

              var file = JSON.stringify(json);
              paramss.Body = file;
              paramss.ContentType = "application/json";
              paramss.CacheControl = "max-age=300";
              s3bucket.putObject(paramss, function (err, datass) {
                if (!err) {
                  cloudfront.createInvalidation(
                    cloudfrontParams,
                    function (err, data) {
                      if (err) console.log(err, err.stack);
                      else callback(data);
                    }
                  );
                }
              });
            });
          }
        });
      });
    } catch (error) {
      console.error("Error in uploadToS3:", error);
      callback(error);
    }
  },

  async updateBannerLink(link, banner, callback) {
    try {
      // Initialize AWS configuration
      const config = await initializeAwsConfig();

      let s3bucket = new AWS.S3({
        region: config.bucketRegion,
        accessKeyId: config.accessKeyId,
        secretAccessKey: config.secretAccessKey,
        Bucket: config.bucketName,
        endpoint: config.s3Endpoint,
        s3ForcePathStyle: true,
      });

      var paramss = {
        Bucket: config.bucketName,
        Key: "app/v1.json",
      };

      s3bucket.getObject(paramss, function (err, existingdata) {
        var defaultJson = { view: { top_banner_image_url: "", top_banner_link_url: "" }, view_us: { top_banner_image_url: "", top_banner_link_url: "" } };
        var json = (existingdata && existingdata.Body)
          ? JSON.parse(existingdata.Body.toString("utf-8"))
          : defaultJson;
        if (banner == "US") {
          if (!json.view_us) json.view_us = {};
          json.view_us.top_banner_link_url = link;
        } else {
          if (!json.view) json.view = {};
          json.view.top_banner_link_url = link;
        }
        var file = JSON.stringify(json);
        paramss.Body = file;
        paramss.ContentType = "application/json";
        paramss.CacheControl = "max-age=300"; // 5-minute cache, removed must-revalidate for iOS compatibility
        s3bucket.putObject(paramss, function (err, datass) {
          if (!err) {
            cloudfront.createInvalidation(
              cloudfrontParams,
              function (err, data) {
                if (err) console.log(err, err.stack); // an error occurred
                else callback(datass); // successful response
              }
            );
          }
        });
      });
    } catch (error) {
      console.error("Error in updateBannerLink:", error);
      callback(error);
    }
  },

  async selectNoImage(arg, callback) {
    try {
      // Initialize AWS configuration
      const config = await initializeAwsConfig();

      let s3bucket = new AWS.S3({
        region: config.bucketRegion,
        accessKeyId: config.accessKeyId,
        secretAccessKey: config.secretAccessKey,
        Bucket: config.bucketName,
        endpoint: config.s3Endpoint,
        s3ForcePathStyle: true,
      });

      var paramss = {
        Bucket: config.bucketName,
        Key: "app/v1.json",
      };

      s3bucket.getObject(paramss, function (err, existingdata) {
        var defaultJson = { view: { top_banner_image_url: "", top_banner_link_url: "" }, view_us: { top_banner_image_url: "", top_banner_link_url: "" } };
        var json = (existingdata && existingdata.Body)
          ? JSON.parse(existingdata.Body.toString("utf-8"))
          : defaultJson;
        if (arg == "US") {
          if (!json.view_us) json.view_us = {};
          json.view_us.top_banner_image_url = "";
        } else {
          if (!json.view) json.view = {};
          json.view.top_banner_image_url = "";
        }
        var file = JSON.stringify(json);
        paramss.Body = file;
        paramss.ContentType = "application/json";
        paramss.CacheControl = "max-age=300"; // 5-minute cache, removed must-revalidate for iOS compatibility
        s3bucket.putObject(paramss, function (err, datass) {
          if (!err) {
            cloudfront.createInvalidation(
              cloudfrontParams,
              function (err, data) {
                if (err) console.log(err, err.stack); // an error occurred
                else callback(datass); // successful response
              }
            );
          }
        });
      });
    } catch (error) {
      console.error("Error in selectNoImage:", error);
      callback(error);
    }
  },

  async getUploadedBanner(callback) {
    try {
      // Initialize AWS configuration
      const config = await initializeAwsConfig();

      let s3bucket = new AWS.S3({
        region: config.bucketRegion,
        accessKeyId: config.accessKeyId,
        secretAccessKey: config.secretAccessKey,
        Bucket: config.bucketName,
        endpoint: config.s3Endpoint,
        s3ForcePathStyle: true,
      });

      var paramss = {
        Bucket: config.bucketName,
        Key: "app/v1.json",
      };
      s3bucket.getObject(paramss, function (err, existingdata) {
        if (err || !existingdata || !existingdata.Body) {
          callback(err || new Error('app/v1.json not found or empty'));
        } else {
          var json = JSON.parse(existingdata.Body.toString("utf-8"));
          callback(json);
        }
      });
    } catch (error) {
      console.error("Error in getUploadedBanner:", error);
      callback(error);
    }
  },

  async uploadAndGetBannerLink(file, banner, callback) {
    try {
      console.log("uploadAndGetBannerLink called with:", file, banner);
      // Initialize AWS configuration
      const config = await initializeAwsConfig();
      console.log("AWS config loaded:", config);

      let s3bucket = new AWS.S3({
        region: config.bucketRegion,
        accessKeyId: config.accessKeyId,
        secretAccessKey: config.secretAccessKey,
        Bucket: config.bucketName,
        endpoint: config.s3Endpoint,
        s3ForcePathStyle: true,
      });

      s3bucket.createBucket(function (data) {
        // Determine ContentType from file extension
        let contentType = "image/jpeg"; // default
        const fileName = file.name.toLowerCase();
        if (fileName.endsWith(".png")) {
          contentType = "image/png";
        } else if (fileName.endsWith(".gif")) {
          contentType = "image/gif";
        } else if (fileName.endsWith(".jpg") || fileName.endsWith(".jpeg")) {
          contentType = "image/jpeg";
        }

        // Generate date-based path
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");

        const safeFileName = generateFileName(file.name);
        var params = {
          Bucket: config.bucketName,
          Key: `uploads/${year}/${month}/${safeFileName}`,
          Body: file.data,
          ContentType: contentType,
          ACL: 'public-read',
        };

        s3bucket.upload(params, function (err, data) {
          if (err) {
            callback(err);
          } else {
            var paramss = {
              Bucket: config.bucketName,
              Key: "app/v1.json",
            };
            s3bucket.getObject(paramss, function (err, existingdata) {
              console.log("data-->>", data);
              console.log("err-->>", err);
              callback(data.Location);

              // var file = JSON.stringify(json)
              // paramss.Body = file
              // s3bucket.putObject(paramss, function (err, datass) {
              //   if (!err) {
              //     cloudfront.createInvalidation(cloudfrontParams, function (err, data) {
              //       if (err) console.log(err, err.stack) // an error occurred
              //       else callback(data) // successful response
              //     })

              //   }
              // })
            });
          }
        });
      });
    } catch (error) {
      console.error("Error in uploadAndGetBannerLink:", error);
      callback(error);
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/s3Upload.js